import React from 'react'
import Herosection from './Herosection.jsx'
import Navber from '../../../Components/Navber.jsx'
import AboutSection from './AboutSection.jsx'
import FeaturedDestinations from './FeaturedDestinations.jsx'
import WhyJayraj from './WhyJayraj.jsx'
import Testimonials from './Testimonials.jsx'

function MainLayout() {
  return (
    <div>
      <Navber />
      <Herosection />
      <FeaturedDestinations />
        <AboutSection />
        
        <WhyJayraj />
        <Testimonials/>
    </div>
  )
}

export default MainLayout